import { render, staticRenderFns } from "./VaffMediaDisplay.vue?vue&type=template&id=ccb206ae&scoped=true&"
import script from "./VaffMediaDisplay.vue?vue&type=script&lang=js&"
export * from "./VaffMediaDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VaffMediaDisplay.vue?vue&type=style&index=0&id=ccb206ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb206ae",
  null
  
)

export default component.exports